import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Menu } from "lucide-react";
import SuperSidebar from "./components/SuperSidebar";

export default function SuperLayout() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="flex gap-4 h-screen p-2">
      {/* Mobile hamburger button */}
      <button
        className={`md:hidden fixed top-2 left-2 z-50 p-2 rounded-lg bg-c-gray-600 text-white ${mobileMenuOpen ? "hidden" : ""}`}
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        aria-label="Toggle menu"
      >
        <Menu className="h-6 w-6" />
      </button>

      {/* Desktop sidebar */}
      <div className="hidden md:flex md:min-w-fit">
        <SuperSidebar />
      </div>

      {/* Mobile sidebar overlay */}
      {mobileMenuOpen && (
        <div
          className="fixed inset-0 z-40 md:hidden"
          onClick={() => setMobileMenuOpen(false)}
        >
          <div className="absolute inset-0 bg-black/50" />
          <div
            className="relative w-72 h-full bg-c-gray-700 p-2 overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <SuperSidebar onNavigate={() => setMobileMenuOpen(false)} />
          </div>
        </div>
      )}

      {/* Main content */}
      <div className="flex flex-col w-full overflow-auto md:pt-0 pt-16">
        <Outlet />
      </div>
    </div>
  );
}
